import { render } from "./TipImpactCard.vue?vue&type=template&id=4116e7e9&scoped=true"
import script from "./TipImpactCard.vue?vue&type=script&lang=js"
export * from "./TipImpactCard.vue?vue&type=script&lang=js"

import "./TipImpactCard.vue?vue&type=style&index=0&id=4116e7e9&scoped=true&lang=scss"

import exportComponent from "/Users/cp/Code/betslip/BetslipPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4116e7e9"]])

export default __exports__